import React, { useEffect, useState } from "react";
import classes from "./Faq.module.scss";
import noise from "../../media/noise.png";
import { useTranslation } from "react-i18next";
import { fetchLocalizedCollection } from "../../constants/cms-locale.constant.ts";
import QuestionBlock from "../../components/frequently-asked-questions/QuestionBlock.tsx";
import ClipLoader from "react-spinners/ClipLoader";

const Faq = () => {
  const { t, i18n } = useTranslation();
  const [openedBlockId, setOpenedBlockId] = useState(null);
  const [blocks, setBlocks] = useState([]);
  const [loading, setLoading] = useState(false);
  const getData = async () => {
    try {
      const faqs = await fetchLocalizedCollection(
        "faqs?sort[0]=order:asc&sort[1]=createdAt:asc&pagination[pageSize]=100",
        i18n.language,
      );
      // `order` is shared between locales, re-sort after merging translated and untranslated entries
      faqs.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
      setBlocks(
        faqs.map((item) => ({
          documentId: item.documentId,
          title: item.question,
          text: item.answer,
        })),
      );
      setOpenedBlockId(faqs[0]?.documentId);
    } catch (err) {
      setBlocks([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);
    getData();
  }, []);

  const openBlockHandler = (id) => {
    if (id === openedBlockId) setOpenedBlockId(null);
    else setOpenedBlockId(id);
  };

  return (
    <main>
      <section
        className={`section--1 ${classes["heading-section"]}`}
        id="nav-dark"
      >
        <div className="circle circle--4"></div>
        <div className="circle circle--3"></div>
        <div className="circle circle--2"></div>
        <div className="circle circle--1"></div>
        <img src={noise} alt={"noise background"} className="noise" />

        <div className={classes.container}>
          <div className={classes.text}>{t("faqPage.title")}</div>
        </div>
      </section>

      <section className="section--light-gray">
        {loading && (
          <div id="nav-dark" className={classes["loading-container"]}>
            <ClipLoader size={120} color="#182347" />
          </div>
        )}
        {!loading && (
          <div className={classes.content}>
            <div className={classes.left}>
              <div className={classes["left--container"]}>
                {blocks.map(({ title, documentId }) => (
                  <button
                    onClick={() => openBlockHandler(documentId)}
                    className={`${classes.item} ${documentId === openedBlockId ? classes.selected : ""}`}
                    key={documentId}
                  >
                    {title}
                  </button>
                ))}
              </div>
            </div>
            <div className={classes.right}>
              {blocks.map(({ title, documentId, text }) => (
                <QuestionBlock
                  key={documentId}
                  title={title}
                  id={documentId}
                  openBlock={() => openBlockHandler(documentId)}
                  isOpened={documentId === openedBlockId}
                  description={text}
                  textClassName={classes["block-text"]}
                />
              ))}
            </div>
          </div>
        )}
      </section>
    </main>
  );
};

export default Faq;
